import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import api from '../api';

export default function Login() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [form, setForm] = useState({ kullanici_adi: '', sifre: '' });
  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  // 'giris' | 'unutum_email' | 'unutum_kod' | 'unutum_sifre'
  const [adim, setAdim] = useState('giris');
  const [resetEmail, setResetEmail] = useState('');
  const [resetToken, setResetToken] = useState('');
  const [resetKod, setResetKod] = useState('');
  const [yeniSifre, setYeniSifre] = useState('');
  const [yeniSifreTekrar, setYeniSifreTekrar] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata(''); setYukleniyor(true);
    try {
      const res = await api.post('/auth/login', form);
      login(res.data);
      navigate('/dashboard');
    } catch (err) {
      setHata(err.response?.data?.hata || 'Giriş başarısız');
    } finally { setYukleniyor(false); }
  };

  const handleResetTalep = async (e) => {
    e.preventDefault();
    setHata(''); setYukleniyor(true);
    try {
      const res = await api.post('/auth/sifre-sifirlama-talep', { email: resetEmail });
      setResetToken(res.data.token || '');
      setBilgi(res.data.mesaj);
      setAdim('unutum_kod');
    } catch (err) {
      setHata(err.response?.data?.hata || 'İşlem başarısız');
    } finally { setYukleniyor(false); }
  };

  const handleResetDogrula = async (e) => {
    e.preventDefault();
    setHata(''); setYukleniyor(true);
    try {
      // Kodu doğrulamak için sadece token + kod kontrol ederiz (şifre henüz güncellenmez)
      // Basit doğrulama: bir sonraki adıma geç, şifreyi son adımda gönder
      if (!resetKod || resetKod.length !== 6) {
        setHata('Lütfen 6 haneli kodu girin');
        setYukleniyor(false);
        return;
      }
      setAdim('unutum_sifre');
    } catch (err) {
      setHata(err.response?.data?.hata || 'Hata');
    } finally { setYukleniyor(false); }
  };

  const handleResetSifre = async (e) => {
    e.preventDefault();
    setHata(''); setYukleniyor(true);
    if (yeniSifre !== yeniSifreTekrar) {
      setHata('Şifreler eşleşmiyor');
      setYukleniyor(false);
      return;
    }
    if (yeniSifre.length < 6) {
      setHata('Şifre en az 6 karakter olmalı');
      setYukleniyor(false);
      return;
    }
    try {
      const res = await api.post('/auth/sifre-sifirlama-dogrula', {
        token: resetToken,
        kod: resetKod,
        yeni_sifre: yeniSifre,
      });
      setBilgi(res.data.mesaj);
      setAdim('giris');
      setResetEmail(''); setResetToken(''); setResetKod(''); setYeniSifre(''); setYeniSifreTekrar('');
    } catch (err) {
      setHata(err.response?.data?.hata || 'Hata');
    } finally { setYukleniyor(false); }
  };

  const geriDon = () => { setAdim('giris'); setHata(''); setBilgi(''); };

  return (
    <div className="login-page">
      <div className="login-card">
        <img className="login-logo" src="/ub.png" alt="Ünye Belediyesi logosu" />
        <h1>ÜNYE BELEDİYESİ</h1>
        <p>İşyeri Ruhsat Yönetim Sistemi</p>

        {bilgi && <div className="alert alert-success">{bilgi}</div>}
        {hata && <div className="alert alert-error">{hata}</div>}

        {adim === 'giris' && (
          <form onSubmit={handleSubmit}>
            <div className="form-group" style={{marginBottom:'16px'}}>
              <label>Kullanıcı Adı veya E-posta</label>
              <input
                type="text"
                value={form.kullanici_adi}
                onChange={e => setForm({...form, kullanici_adi: e.target.value})}
                placeholder="Kullanıcı adı veya e-posta adresinizi girin"
                required
              />
            </div>
            <div className="form-group" style={{marginBottom:'16px'}}>
              <label>Şifre</label>
              <input
                type="password"
                value={form.sifre}
                onChange={e => setForm({...form, sifre: e.target.value})}
                placeholder="Şifrenizi girin"
                required
              />
            </div>
            <div style={{textAlign:'right', marginBottom:'16px'}}>
              <button
                type="button"
                onClick={() => { setAdim('unutum_email'); setHata(''); setBilgi(''); }}
                style={{background:'none', border:'none', color:'#3949ab', cursor:'pointer', fontSize:'13px', textDecoration:'underline', padding:0}}
              >
                Şifremi Unuttum
              </button>
            </div>
            <button type="submit" className="btn btn-primary" style={{width:'100%', padding:'12px'}} disabled={yukleniyor}>
              {yukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </button>
            <a href="/sso-login.html" className="btn btn-outline" style={{display:'block', textAlign:'center', marginTop:12, padding:12}}>
              Kurumsal hesap ile giriş
            </a>
          </form>
        )}

        {adim === 'unutum_email' && (
          <form onSubmit={handleResetTalep}>
            <p style={{fontSize:'13px', color:'#555', marginBottom:'16px'}}>
              Kayıtlı e-posta adresinizi girin. Şifre sıfırlama kodu gönderilecektir.
            </p>
            <div className="form-group" style={{marginBottom:'20px'}}>
              <label>E-posta Adresi *</label>
              <input
                type="email"
                value={resetEmail}
                onChange={e => setResetEmail(e.target.value)}
                placeholder="ornek@unye.bel.tr"
                required
              />
            </div>
            <div style={{display:'flex', gap:'10px'}}>
              <button type="button" className="btn btn-outline" style={{flex:1}} onClick={geriDon}>← Geri</button>
              <button type="submit" className="btn btn-primary" style={{flex:2}} disabled={yukleniyor}>
                {yukleniyor ? 'Gönderiliyor...' : '📧 Kod Gönder'}
              </button>
            </div>
          </form>
        )}

        {adim === 'unutum_kod' && (
          <form onSubmit={handleResetDogrula}>
            <p style={{fontSize:'13px', color:'#555', marginBottom:'4px'}}>
              <strong>{resetEmail}</strong> adresine gönderilen 6 haneli kodu girin.
            </p>
            <p style={{fontSize:'12px', color:'#999', marginBottom:'16px'}}>Kodu göremiyorsanız spam klasörünü kontrol edin.</p>
            <div className="form-group" style={{marginBottom:'20px'}}>
              <label>Doğrulama Kodu *</label>
              <input
                type="text"
                value={resetKod}
                onChange={e => setResetKod(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="123456"
                maxLength={6}
                style={{fontSize:'24px', letterSpacing:'8px', textAlign:'center'}}
                required
              />
            </div>
            <div style={{display:'flex', gap:'10px'}}>
              <button type="button" className="btn btn-outline" style={{flex:1}} onClick={() => setAdim('unutum_email')}>← Geri</button>
              <button type="submit" className="btn btn-primary" style={{flex:2}} disabled={yukleniyor}>
                {yukleniyor ? '...' : 'Devam Et →'}
              </button>
            </div>
            <div style={{textAlign:'center', marginTop:'12px'}}>
              <button type="button" onClick={() => { setAdim('unutum_email'); setBilgi(''); }} style={{background:'none', border:'none', color:'#3949ab', cursor:'pointer', fontSize:'12px', textDecoration:'underline'}}>
                Kodu tekrar gönder
              </button>
            </div>
          </form>
        )}

        {adim === 'unutum_sifre' && (
          <form onSubmit={handleResetSifre}>
            <p style={{fontSize:'13px', color:'#555', marginBottom:'16px'}}>Yeni şifrenizi belirleyin.</p>
            <div className="form-group" style={{marginBottom:'12px'}}>
              <label>Yeni Şifre *</label>
              <input
                type="password"
                value={yeniSifre}
                onChange={e => setYeniSifre(e.target.value)}
                placeholder="En az 6 karakter"
                minLength={6}
                required
              />
            </div>
            <div className="form-group" style={{marginBottom:'20px'}}>
              <label>Yeni Şifre (Tekrar) *</label>
              <input
                type="password"
                value={yeniSifreTekrar}
                onChange={e => setYeniSifreTekrar(e.target.value)}
                placeholder="Şifreyi tekrar girin"
                required
              />
            </div>
            <button type="submit" className="btn btn-primary" style={{width:'100%', padding:'12px'}} disabled={yukleniyor}>
              {yukleniyor ? 'Güncelleniyor...' : '🔑 Şifreyi Güncelle'}
            </button>
          </form>
        )}

        <p style={{textAlign:'center', marginTop:'20px', color:'#999', fontSize:'12px'}}>
          © 2026 Ünye Belediye Başkanlığı
        </p>
      </div>
    </div>
  );
}
